export default __webpack_public_path__ + "static/media/slide_2.a5d8646f.png";